import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import styles from "./Welcome.module.css";

const Welcome = () => {
    const { t } = useTranslation();

    return (
        <main className={styles.page}>
            <Helmet>
                <title>{t("welcome.pageTitle")}</title>
            </Helmet>

            <section className={styles.hero}>
                <div className={styles.heroContent}>
                    <div className={styles.heroText}>
                        <h1 className={styles.heroTitle}>{t("welcome.heroTitle")}</h1>
                        <p className={styles.heroSubtitle}>{t("welcome.heroSubtitle")}</p>
                        <div className={styles.heroActions}>
                            <a className={styles.primaryButton} href="https://ama.actemium-maintenance.net" target="_blank" rel="noopener noreferrer">
                                {t("welcome.heroPrimaryCta")}
                            </a>
                            <a className={styles.secondaryButton} href="https://syma.actemium-maintenance.net" target="_blank" rel="noopener noreferrer">
                                {t("welcome.heroSecondaryCta")}
                            </a>
                        </div>
                    </div>
                    <div className={styles.heroPanel}>
                        <h2 className={styles.heroPanelTitle}>{t("welcome.heroPanelTitle")}</h2>
                        <ul className={styles.heroPanelList}>
                            <li>
                                <span className={styles.brandText}>{t("welcome.heroPanelItem1Highlight1")}</span> {t("welcome.heroPanelItem1Middle")}{" "}
                                <span className={styles.brandText}>{t("welcome.heroPanelItem1Highlight2")}</span> {t("welcome.heroPanelItem1Suffix")}
                            </li>
                            <li>
                                <span className={styles.brandText}>{t("welcome.heroPanelItem2Highlight1")}</span> {t("welcome.heroPanelItem2Middle")}{" "}
                                <span className={styles.brandText}>{t("welcome.heroPanelItem2Highlight2")}</span> {t("welcome.heroPanelItem2Suffix")}{" "}
                                <span className={styles.brandText}>{t("welcome.heroPanelItem2Highlight3")}</span>.
                            </li>
                            <li>
                                <span className={styles.brandText}>{t("welcome.heroPanelItem3Highlight1")}</span> {t("welcome.heroPanelItem3Middle")}{" "}
                                <span className={styles.brandText}>{t("welcome.heroPanelItem3Highlight2")}</span> {t("welcome.heroPanelItem3And")}{" "}
                                <span className={styles.brandText}>{t("welcome.heroPanelItem3Highlight3")}</span>
                                {t("welcome.heroPanelItem3Suffix")}
                            </li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h2>{t("welcome.toolsTitle")}</h2>
                    <p>{t("welcome.toolsIntro")}</p>
                </div>
                <div className={styles.toolGrid}>
                    <article className={styles.toolCard}>
                        <h3>
                            <a className={styles.cardTitleLink} href="https://ama.actemium-maintenance.net" target="_blank" rel="noopener noreferrer">
                                {t("welcome.amaTitle")}
                            </a>
                        </h3>
                        <p>{t("welcome.amaDescription")}</p>
                    </article>
                    <article className={styles.toolCard}>
                        <h3>
                            <a className={styles.cardTitleLink} href="https://syma.actemium-maintenance.net" target="_blank" rel="noopener noreferrer">
                                {t("welcome.symaTitle")}
                            </a>
                        </h3>
                        <p>{t("welcome.symaDescription")}</p>
                    </article>
                </div>
            </section>

            <section className={styles.sectionAlt}>
                <div className={styles.sectionContent}>
                    <h2 className={styles.brandHeading}>{t("welcome.aboutTitle")}</h2>
                    <p>
                        <span className={styles.brandText}>{t("welcome.company1")}</span>, <span className={styles.brandText}>{t("welcome.company2")}</span>{" "}
                        {t("welcome.aboutBodyAnd")} <span className={styles.brandText}>{t("welcome.company3")}</span> {t("welcome.aboutBodyOutro")}
                    </p>
                </div>
            </section>

            <section className={styles.section}>
                <div className={styles.sectionHeader}>
                    <h2>{t("welcome.capabilitiesTitle")}</h2>
                    <p>{t("welcome.capabilitiesIntro")}</p>
                </div>
                <div className={styles.capabilityGrid}>
                    <div className={styles.capabilityCard}>
                        <h3>{t("welcome.capability1Title")}</h3>
                        <p>{t("welcome.capability1Body")}</p>
                    </div>
                    <div className={styles.capabilityCard}>
                        <h3>{t("welcome.capability2Title")}</h3>
                        <p>{t("welcome.capability2Body")}</p>
                    </div>
                    <div className={styles.capabilityCard}>
                        <h3>{t("welcome.capability3Title")}</h3>
                        <p>{t("welcome.capability3Body")}</p>
                    </div>
                </div>
            </section>

            <footer className={styles.footer}>
                <div className={styles.footerLinks}>
                    <a
                        className={styles.cardTitleLink}
                        href="https://www.actemium.fr/implantations/actemium-maintenance-airport-logistics/presentation/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("welcome.company1")}
                    </a>
                    <a
                        className={styles.cardTitleLink}
                        href="https://www.actemium.fr/implantations/actemium-maintenance-logistique-paris/presentation/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("welcome.company2")}
                    </a>
                    <a
                        className={styles.cardTitleLink}
                        href="https://www.actemium.fr/implantations/actemium-maintenance-aeroportuaire-paris/presentation/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("welcome.company3")}
                    </a>
                </div>
                <div className={styles.footerContact}>
                    <h3>{t("welcome.contactTitle")}</h3>
                    <p>
                        {t("welcome.contactIntro")}{" "}
                        <a className={styles.cardTitleLink} href="mailto:contact.amal@actemium.com">
                            contact.amal@actemium.com
                        </a>
                    </p>
                </div>
            </footer>
        </main>
    );
};

export default Welcome;
